/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AttributeType {
  Int = "Int",
  String = "String",
}

export enum ColorType {
  Orange = "Orange",
  Purple = "Purple",
  Red = "Red",
  Yellow = "Yellow",
}

export enum InvariantTranslationKey {
  Correction = "Correction",
  Error = "Error",
}

export enum LightsSettings3JSTypes {
  DirectionalLight3JS = "DirectionalLight3JS",
  HemisphereLight3JS = "HemisphereLight3JS",
}

export enum ModuleType {
  Aux = "Aux",
  Main = "Main",
}

export enum RequestSortDirection {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum StockStatus {
  Available = "Available",
  NotAvailable = "NotAvailable",
}

export enum SubjectType {
  AttributesType = "AttributesType",
  CatalogType = "CatalogType",
  MaterialsType = "MaterialsType",
  ModuleBlueprintType = "ModuleBlueprintType",
  ModuleVariantType = "ModuleVariantType",
  RetailerType = "RetailerType",
  TexturesType = "TexturesType",
}

export enum VariantTranslationKey {
  Description = "Description",
  Title = "Title",
}

export enum VersionedStatusTypes {
  Archived = "Archived",
  Draft = "Draft",
  Published = "Published",
}

export enum VisualChangeTypes {
  Invisible = "Invisible",
  MaterialChange = "MaterialChange",
  Translation = "Translation",
}

export enum WebhookFlowType {
  codegetredirect = "codegetredirect",
  directbase64encodedpayload = "directbase64encodedpayload",
  gammasendmessage = "gammasendmessage",
  hornbachsendmessage = "hornbachsendmessage",
}

export enum WoodType {
  douglas = "douglas",
  grenen = "grenen",
}

export interface ArchivedInput {
  version: number;
}

export interface AssetInput {
  id: any;
  filename: string;
  mimeType?: string | null;
  directory: string;
}

export interface AttributeFilterSettingGqlInput {
  valueIcons: StringOptionAssetInputList;
}

export interface AttributeInput {
  name: string;
  attributeType: AttributeType;
  title: string;
}

export interface BbColorInput {
  color: ColorType;
  id?: any | null;
  overlapAllowed?: boolean | null;
}

export interface BlueprintInvariantTemplateInput {
  name?: string | null;
  invariants: InvariantInput[];
}

export interface BoundingBoxInput {
  position: Vec3Input;
  size: BoundingBoxSizeInput;
  color: BbColorInput;
}

export interface BoundingBoxSizeInput {
  width: number;
  height: number;
  length: number;
}

export interface CatalogCategoryInput {
  title: string;
  moduleCategoryIds: any[];
}

export interface CatalogInput {
  categories: CatalogCategoryInput[];
  filterSettings?: StringModuleCategoryFilterSettingGqlInputList | null;
}

export interface ColorCodesInput {
  button: string;
  buttonPrimaryHover: string;
  buttonSecondaryHover: string;
  gradient1: string;
  gradient2: string;
  cartButton: string;
  cartButtonHover: string;
  background: string;
  selectedItemBackground: string;
  bodyText: string;
  headerText: string;
  selectedItem: string;
  icons: string;
  activeStep: string;
  inactiveStep: string;
  dropShadow: string;
  warn: string;
  border: string;
}

export interface ConfiguratorIconsInput {
  measurement?: AssetInput | null;
  woodType?: AssetInput | null;
  reset?: AssetInput | null;
}

export interface ConfiguratorOptionsInput {
  favicon?: AssetInput | null;
  banner?: AssetInput | null;
  font?: FontInput | null;
  configuratorIcons?: ConfiguratorIconsInput | null;
  priceAppearance?: PriceAppearanceInput | null;
  bottomLogo?: boolean | null;
  saveButton?: boolean | null;
  hideSteps?: boolean | null;
  hideMenuSaveButton?: boolean | null;
  hideMenuOpenButton?: boolean | null;
  hideShareContent?: boolean | null;
  extraCardWidth?: number | null;
  discountedPriceAppearance?: DiscountedPriceAppearanceInput | null;
  hoverOverEffectEnabled?: boolean | null;
  environmentSettingsEditView?: EnvironmentSettings3JSInput | null;
  environmentSettingsResultView?: EnvironmentSettings3JSInput | null;
  saveWithMail?: boolean | null;
}

export interface CurrencyOptionsInput {
  currency: any;
  showCurrency: boolean;
  locale: any;
  showThousandsSeparator: boolean;
}

export interface DirectionalLight3JSInput {
  position: Vec3Input;
  color?: string | null;
  intensity?: number | null;
  shadowSettings?: LightShadowSettingsInput | null;
  target?: Vec3Input | null;
}

export interface DiscountedPriceAppearanceInput {
  strikeThrough?: boolean | null;
  textSize?: number | null;
  color?: string | null;
}

export interface DocumentationInput {
  id: any;
  subjectType: SubjectType;
  fields: PropertyFieldInput[];
  comment?: string | null;
}

export interface DoubleSKUInputMap {
  values: DoubleSKUInputPair[];
}

export interface DoubleSKUInputPair {
  key: number;
  value: string;
}

export interface DraftInput {
  dummy: string;
}

export interface EanOptionsInput {
  eanEnabled: boolean;
}

export interface EnvMapSettings3JSInput {
  url: string;
  height: number;
  radius: number;
}

export interface EnvironmentSettings3JSInput {
  envMapSettings?: EnvMapSettings3JSInput | null;
  lightsSettings?: LightsSettings3JSInput[] | null;
  shadowFloorOpacity?: number | null;
}

export interface EventTemplateInput {
  name?: string | null;
  events: EventsInput;
}

export interface EventsInput {
  onAttach?: string | null;
  onDelete?: string | null;
  onCreated?: string | null;
  onChange?: string | null;
}

export interface FontInput {
  regularFontAsset?: AssetInput | null;
  boldFontAsset?: AssetInput | null;
  italicFontAsset?: AssetInput | null;
  mediumFontAsset?: AssetInput | null;
}

export interface HelpItemInput {
  order: number;
  title: string;
  videoAsset?: AssetInput | null;
  thumbnailAsset?: AssetInput | null;
}

export interface HemisphereLight3JSInput {
  position: Vec3Input;
  skyColor?: string | null;
  groundColor?: string | null;
  intensity?: number | null;
}

export interface HornbachOptionsInput {
  integrationServiceUrl: string;
  articleId: string;
  companyCode: string;
  locale: any;
}

export interface IdAttributeStringInputMap {
  values: IdAttributeStringInputPair[];
}

export interface IdAttributeStringInputPair {
  key: any;
  value: string;
}

export interface IdModulePlacementListSpacialPositionInputInputMap {
  values: IdModulePlacementListSpacialPositionInputInputPair[];
}

export interface IdModulePlacementListSpacialPositionInputInputPair {
  key: any;
  value: SpacialPositionInput[];
}

export interface InvariantInput {
  id: any;
  name?: string | null;
  rule: string;
  correction?: string | null;
  translations: InvariantTranslationKeyStringInputMap;
  disableDuringOnChange?: boolean | null;
}

export interface InvariantTranslationKeyStringInputMap {
  values: InvariantTranslationKeyStringInputPair[];
}

export interface InvariantTranslationKeyStringInputPair {
  key: InvariantTranslationKey;
  value: string;
}

export interface InvisibleInput {
  name: string;
}

export interface ItemPriceStockInput {
  stock: StockStatus;
  price: number;
  EAN?: string | null;
  internalCode?: string | null;
  purchasePrice?: number | null;
  discountPrice?: number | null;
}

export interface LightShadowSettingsInput {
  mapSize: number;
  bias: number;
  cameraLeft: number;
  cameraRight: number;
  cameraTop: number;
  cameraBottom: number;
}

export interface LightsSettings3JSInput {
  type: LightsSettings3JSTypes;
  directionallight3js?: DirectionalLight3JSInput | null;
  hemispherelight3js?: HemisphereLight3JSInput | null;
}

export interface LinkInput {
  href: string;
  text: string;
}

export interface LocalizedStringForAppInput {
  values: StringStringInputMap;
}

export interface LocalizedStringForAttributeInput {
  values: StringStringInputMap;
}

export interface LocalizedStringForInvariantInput {
  values: StringStringInputMap;
}

export interface LocalizedVariantInput {
  groupId: string;
  values: VariantTranslationKeyStringInputMap;
}

export interface MaterialChangeInput {
  changes: StringStringInputMap;
}

export interface MaterialInput {
  name: string;
  color?: string | null;
  roughness?: number | null;
  metalness?: number | null;
  map?: string | null;
  lightMap?: string | null;
  lightMapIntensity?: number | null;
  aoMap?: string | null;
  aoMapIntensity?: number | null;
  emissive?: string | null;
  emissiveIntensity?: number | null;
  emissiveMap?: string | null;
  bumpMap?: string | null;
  bumpScale?: number | null;
  normalMap?: string | null;
  normalMapType?: number | null;
  normalScale?: Vec2Input | null;
  displacementMap?: string | null;
  displacementScale?: number | null;
  displacementBias?: number | null;
  roughnessMap?: string | null;
  metalnessMap?: string | null;
  alphaMap?: string | null;
  envMap?: string | null;
  envMapIntensity?: number | null;
  wireframe?: boolean | null;
  wireframeLinewidth?: number | null;
  fog?: boolean | null;
  flatShading?: boolean | null;
  alphaTest?: number | null;
  alphaToCoverage?: boolean | null;
  blendDst?: number | null;
  blendDstAlpha?: number | null;
  blendEquation?: number | null;
  blendEquationAlpha?: number | null;
  blending?: number | null;
  blendSrc?: number | null;
  blendSrcAlpha?: number | null;
  clipIntersection?: boolean | null;
  clippingPlanes?: PlaneInput[] | null;
  clipShadows?: boolean | null;
  colorWrite?: boolean | null;
  depthFunc?: number | null;
  depthTest?: boolean | null;
  depthWrite?: boolean | null;
  opacity?: number | null;
  polygonOffset?: boolean | null;
  polygonOffsetFactor?: number | null;
  polygonOffsetUnits?: number | null;
  precision?: string | null;
  premultipliedAlpha?: boolean | null;
  dithering?: boolean | null;
  side?: number | null;
  shadowSide?: number | null;
  toneMapped?: boolean | null;
  transparent?: boolean | null;
  vertexColors?: boolean | null;
  visible?: boolean | null;
  format?: number | null;
  stencilWrite?: boolean | null;
  stencilFunc?: number | null;
  stencilRef?: number | null;
  stencilWriteMask?: number | null;
  stencilFuncMask?: number | null;
  stencilFail?: number | null;
  stencilZFail?: number | null;
  stencilZPass?: number | null;
}

export interface ModuleBlueprintInput {
  name: string;
  moduleType: ModuleType;
  categoryId: any;
  categoryReference: string;
  xAttachmentPoints: XAttachmentPointInput[];
  yAttachmentPoints: YAttachmentPointInput[];
  invariants: InvariantInput[];
  invariantTemplates: any[];
  events: EventsInput;
  eventTemplateId?: any | null;
  visualXAttachmentPoints?: VisualXAttachmentPointInput[] | null;
  visualYAttachmentPoint?: VisualYAttachmentPointInput | null;
  model?: AssetInput | null;
  status: VersionedStatusInput;
  groupId?: any | null;
  boundingBoxes?: BoundingBoxInput[] | null;
  considerAsFree?: boolean | null;
  orderWeight?: number | null;
}

export interface ModuleCategoryFilterSettingGqlInput {
  attributes: StringAttributeFilterSettingGqlInputList;
}

export interface ModuleCategoryInput {
  id: any;
  reference: string;
  order: number;
  customizable?: boolean | null;
}

export interface ModuleVariantInput {
  id?: any | null;
  skus: string[];
  name: string;
  visualChanges: VisualChangeInput[];
  model?: AssetInput | null;
  attributeValues: IdAttributeStringInputMap;
  showInCatalog?: boolean | null;
  translations: ValueStringInputMap;
  groupId?: string | null;
  featureImage?: AssetInput | null;
}

export interface PlaneInput {
  normal: Vec3Input;
  constant: number;
}

export interface PriceAppearanceInput {
  font?: AssetInput | null;
  color?: string | null;
}

export interface PropertyFieldInput {
  fieldName: string;
  fieldType: string;
  required?: boolean | null;
}

export interface PublishedInput {
  dummy: string;
}

export interface RequestSort {
  column: string;
  direction: RequestSortDirection;
}

export interface RetailerInput {
  name: string;
  location: string;
  email: string;
  safetyEnvironment: SafetyEnvironmentInput;
  retailerOptions: RetailerOptionsInput;
  isDeleted?: boolean | null;
  rank?: number | null;
}

export interface RetailerOptionsInput {
  currencyOptions: CurrencyOptionsInput;
  colorCodes: ColorCodesInput;
  agreementLinks: LinkInput[];
  helpLink?: LinkInput | null;
  woodTypesAvailable: WoodTypeAvailableInput[];
  configurationIdentifier: string;
  resultSceneSkyMaterialReference?: string | null;
  resultSceneFloorMaterialReference?: string | null;
  installationPrices?: DoubleSKUInputMap | null;
  webhookOptions: WebhookOptionsInput;
  purchasePriceMandatory: boolean;
  configuratorOptions: ConfiguratorOptionsInput;
  eanOptions: EanOptionsInput;
  preconfigurations?: string[] | null;
  helpItems?: HelpItemInput[] | null;
  codeParameterName?: string | null;
  hornbachOptions?: HornbachOptionsInput | null;
}

export interface SafetyEnvironmentInput {
  invariants: InvariantInput[];
  invariantTemplates: any[];
}

export interface SafetyEnvironmentInvariantTemplateInput {
  name?: string | null;
  invariants: InvariantInput[];
}

export interface SinglePriceStockInput {
  sku: string;
  data: ItemPriceStockInput;
}

export interface SpacialPositionInput {
  position: Vec3Input;
  orientation?: Vec3Input | null;
}

export interface StringAttributeFilterSettingGqlInputList {
  values: StringAttributeFilterSettingGqlInputTuple2[];
}

export interface StringAttributeFilterSettingGqlInputTuple2 {
  key: string;
  value: AttributeFilterSettingGqlInput;
}

export interface StringModuleCategoryFilterSettingGqlInputList {
  values: StringModuleCategoryFilterSettingGqlInputTuple2[];
}

export interface StringModuleCategoryFilterSettingGqlInputTuple2 {
  key: string;
  value: ModuleCategoryFilterSettingGqlInput;
}

export interface StringOptionAssetInputList {
  values: StringOptionAssetInputTuple2[];
}

export interface StringOptionAssetInputTuple2 {
  key: string;
  value?: AssetInput | null;
}

export interface StringStringInputMap {
  values: StringStringInputPair[];
}

export interface StringStringInputPair {
  key: string;
  value: string;
}

export interface TextureInput {
  name: string;
}

export interface TranslationInput {
  xaps: any[];
  yaps: any[];
  translate: Vec3Input;
  translateModule: boolean;
}

export interface UserInput {
  email: string;
  systemRoles: string[];
  allRoles: any[];
  personalInformation: string[];
  scopes: string[];
}

export interface ValueItemPriceStockInputInputMap {
  values: ValueItemPriceStockInputInputPair[];
}

export interface ValueItemPriceStockInputInputPair {
  key: WoodType;
  value: ItemPriceStockInput;
}

export interface ValueStringInputMap {
  values: ValueStringInputPair[];
}

export interface ValueStringInputPair {
  key: VariantTranslationKey;
  value: string;
}

export interface VariantTranslationKeyStringInputMap {
  values: VariantTranslationKeyStringInputPair[];
}

export interface VariantTranslationKeyStringInputPair {
  key: VariantTranslationKey;
  value: string;
}

export interface Vec2Input {
  x: number;
  y: number;
}

export interface Vec3Input {
  x: number;
  y: number;
  z: number;
}

export interface VersionedStatusInput {
  type: VersionedStatusTypes;
  archived?: ArchivedInput | null;
  draft?: DraftInput | null;
  published?: PublishedInput | null;
}

export interface VisualChangeInput {
  type: VisualChangeTypes;
  invisible?: InvisibleInput | null;
  materialchange?: MaterialChangeInput | null;
  translation?: TranslationInput | null;
}

export interface VisualXAttachmentPointInput {
  position: Vec3Input;
  orientation?: Vec3Input | null;
  xAttachmentPointIds: any[];
}

export interface VisualYAttachmentPointInput {
  position: Vec3Input;
  orientation?: Vec3Input | null;
  yAttachmentPointId: any;
  isEditButton: boolean;
}

export interface WebhookOptionsInput {
  flowType: WebhookFlowType;
  webhookUrls: WebhookUrlsInput;
}

export interface WebhookUrlsInput {
  redirectUrl: string;
}

export interface WoodPriceStockInput {
  sku: string;
  prices: ValueItemPriceStockInputInputMap;
}

export interface WoodTypeAvailableInput {
  woodType: WoodType;
  available: boolean;
}

export interface XAttachmentPointInput {
  id: any;
  position: Vec3Input;
  orientation: Vec3Input;
  properties: string[][];
}

export interface YAttachmentPointInput {
  id: any;
  position: Vec3Input;
  orientation: Vec3Input;
  properties: string[];
}

//==============================================================
// END Enums and Input Objects
//==============================================================
